export interface DataItem {
  id: number;
  statusPgto: string;
  statusConciliacao: string;
  dataPgto: string | null;
  adquirente: string;
  bandeira: string;
  valorPrevisto: string;
  valorDepositado: string;
  diferenca: string;
  banco: string;
  agencia: string;
  conta: string;
  nomeGrupo: string;
  empresa: string;
  cnpj: string;
  ajustes: string;
  justificativa: string;
}

export interface TableOptions {
  statusPgtoOpcoes: string[];
  statusConciliacaoOpcoes: string[];
  adquirentes: string[];
  bandeiras: string[];
  bancos: string[];
  agencias: string[];
  contas: string[];
  empresas: string[];
  cnpjs: string[];
}

export const defaultOptions: TableOptions = {
  statusPgtoOpcoes: [],
  statusConciliacaoOpcoes: [],
  adquirentes: [],
  bandeiras: [],
  bancos: [],
  agencias: [],
  contas: [],
  empresas: [],
  cnpjs: [],
};
